<template>
  <div
    class="j-input-popup-wrapper"
    :class="[disabled ? 'disabled' : '']"
    style="text-align: left"
    @mouseover="isHover = true"
    @mouseout="isHover = false"
  >
    <!-- 3、link（超链接） -->
    <div
      v-if="type == 'link'"
      class="j-input-popup j-input-popup-link"
      :class="[disabled ? '' : 'disabledWhite']"
      :title="text"
    >
      <div class="input-readonly link">
        <div
          class="i-icon i-close-circle"
          v-show="!!linkText && showSearchIcon && allowClear"
          @click.stop="doCloseCircle"
        >
          <a-icon type="close-circle" theme="filled" />
        </div>
        <div
          class="i-icon i-search"
          @click="handleOpen"
          v-show="showSearchIcon"
          :class="[linkText ? 'link-text-show' : '']"
        >
          <a-icon type="search" />
        </div>
        <a class="cursor-pointer" @click="handleOpen('link')" :disabled="disabled">{{ linkText }}</a>
      </div>
      <component
        v-if="!!src"
        v-bind:is="src"
        :params="params"
        v-bind="$attrs"
        ref="ModalForm"
        @emit="getList"
      ></component>
    </div>

    <!-- 2、input （可输入 Input） -->
    <div
      v-else-if="type == 'input'"
      class="j-input-popup j-input-popup-input"
      :class="[disabled ? '' : 'disabledWhite']"
      :title="text"
    >
      <div class="input-readonly">
        <div class="i-icon i-close-circle" v-show="iCloseCircleShow && !disabled" @click.stop="doCloseCircle">
          <a-icon type="close-circle" theme="filled" />
        </div>
        <div class="i-icon i-search" @click="handleOpen">
          <a-icon type="search" />
        </div>
        <a-input
          class="j-input cursor-pointer"
          :disabled="disabled"
          :placeholder="placeholder"
          v-model="text"
          @change="inputChange"
        ></a-input>
      </div>
      <component
        v-if="!!src"
        v-bind:is="src"
        :params="params"
        v-bind="$attrs"
        ref="ModalForm"
        @emit="getList"
      ></component>
    </div>

    <!-- 1、default(默认情况) -->
    <div v-else class="j-input-popup j-input-popup-default" :class="[disabled ? '' : 'disabledWhite']" :title="text">
      <div class="j-input-display" v-show="!showTags">
        <span>{{ text }}</span>
        <span v-for="(outer, index) in extraTexts" :key="index">
          <span v-for="inner in outer" :key="inner">
            <template v-if="split == 'slash'">
              <j-slash v-if="inner"></j-slash>
              <span class="extraTexts" :class="'index' + index">{{ inner }}</span>
            </template>
            <template v-else>
              <span class="inlineNote" v-if="inner">（{{ inner }}）</span>
            </template>
          </span>
        </span>
      </div>

      <div class="input-readonly" @click="handleOpen">
        <!-- 关闭图标 -->
        <div
          class="i-icon i-close-circle"
          v-show="iCloseCircleShow && !disabled && allowClear && isHover"
          @click.stop="doCloseCircle"
        >
          <a-icon type="close-circle" theme="filled" />
        </div>

        <!-- 检索图标 -->
        <div v-show="!(iCloseCircleShow && !disabled && allowClear && isHover)" class="i-icon i-search">
          <a-icon type="search" />
        </div>

        <!-- 输入框 -->
        <a-input
          class="j-input cursor-pointer"
          :placeholder="placeholder"
          :disabled="disabled"
          v-model="text"
          v-show="!showTags"
        ></a-input>

        <!-- 多标签模式 -->
        <a-select
          :allowClear="false"
          :class="tagTheme"
          :getPopupContainer="(target) => target.parentNode"
          class="j-input cursor-pointer"
          mode="multiple"
          :placeholder="placeholder"
          :disabled="disabled"
          :value="returnData"
          v-show="showTags"
          @change="handleChange"
        >
          <a-select-option v-for="(data, index) in returnData" :key="index" :value="data.value">
            <span style="display: inline-block; width: 100%" :title="data.text">{{ data.text }}</span>
          </a-select-option>
        </a-select>
      </div>
      <!-- </a-tooltip> -->

      <component
        v-if="!!src"
        v-bind:is="src"
        :params="params"
        v-bind="$attrs"
        ref="ModalForm"
        @emit="getList"
      ></component>
    </div>
  </div>
</template>

<script>
/******
 *使用用例参考 JInputPopupDemo.vue
 *
 * 1、default(默认情况)
 *
 *必填：component="String"         String   弹出组件的vue文件名称
 *必填：v-model="[]"               Array    使用v-model进行值的传递和接收,与v-decorator互斥
 *必填：v-decorator="[]"           Array    使用v-decorator进行值的传递和接收,与v-model互斥

 *
 *选填: placeholder="placeholder"  String
 *选填：params="{}"                Object
 *选填：disabled="Boolean"         Boolean
 *选填：type='default'             String
 *选填：allowClear="Boolean"       Boolean
 *
 *
 * 2、input （可输入 input）
 *
 *必填：component="String"         String   弹出组件的vue文件名称
 *必填：v-model="[]"               Array    使用v-model进行值的传递和接收,与v-decorator互斥
 *必填：v-decorator="[]"           Array    使用v-decorator进行值的传递和接收,与v-model互斥
 *必填：type='input'               String
 *
 *选填: placeholder="placeholder"  String
 *选填：params="{}"                Object
 *选填：disabled="Boolean"         Boolean
 *
 * 3、link（超链接）
 *
 *必填：component="String"         String   弹出组件的vue文件名称
 *必填：v-model="[]"               Array    使用v-model进行值的传递和接收,与v-decorator互斥
 *必填：v-decorator="[]"           Array    使用v-decorator进行值的传递和接收,与v-model互斥
 *必填：type='link'                String
 *
 *选填: placeholder="placeholder"  String
 *选填：params="{}"                Object
 *选填：disabled="Boolean"         Boolean
 *选填：showSearchIcon="Boolean"   Boolean  falseの場合、虫眼鏡は表示しない
 *
 * 备注：v-model 绑定值--linkText为超链接<a>显示文字
 *
 */
export default {
  name: 'JInputPopup',
  props: {
    component: {
      type: String,
    },
    componentLink: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showTags: {
      type: Boolean,
      default: false,
    },
    tagTheme: {
      type: String,
      // 'default' or 'primary'
      default: 'primary',
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    showSearchIcon: {
      type: Boolean,
      default: true,
    },
    params: {
      type: Object,
    },
    beforeValSet: {
      type: Function,
    },
    beforeLinkOpen: {
      type: Function,
    },
    beforePopupOpen: {
      type: Function,
    },
    placeholder: {
      type: String,
      default: function () {
        if (this.$t) {
          return this.$t('選択してください')
        }
      },
    },
    type: {
      type: String,
      default: () => {
        return 'default'
      },
    },
    split: {
      type: String,
      default: () => {
        return 'slash'
      },
    },
  },
  data() {
    return {
      src: '',
      returnData: [],
      isHover: false,
      components: {
        // ApplyModal
        ApplyModal: 'views/k00/k0011/modules/ApplyModal',

        // K00_14_005_ユーザツリー検索画面（POPUP）
        SelectUserTreeModal: 'views/k00/k0014/modules/SelectUserTreeModal',

        // 选择客户候选人进入公司
        SelectUserIntoCompany: 'views/k03/k0302/modules/SelectUserIntoCompany',

        // 选择客户联系人
        SelectUserCompany: 'views/k03/k0302/modules/SelectUserCompany',

        // K01_02_他会社ユーザ一覧（POPUP）
        TalentBankTag: 'views/k01/k0102/TalentBankTag',

        // K00_02_003_組織検索画面（POPUP）
        SelectDepartTreeModal: 'views/k00/k0002/modules/SelectDepartTreeModal',

        // K00_02_003_外部系统组织检索（楷码、维度）（POPUP）
        SelectExternalDepartModal: 'views/k00/k0002/modules/SelectExternalDepartModal',

        // K04_02_003_施設情報検索(POPUP)
        SelectFacilitiesModal: 'views/k04/facilities/SelectFacilitiesModal',

        // 中标选择画面
        SelectBid: 'views/k03/k0301/SelectBid',

        // 合同选择画面
        SelectContract: 'views/k03/k0301/SelectContract',

        // 履约保函选择画面
        SelectPromiseMoney: 'views/k05/k0505/SelectPromiseMoney',

        // 项目选择画面
        SelectProject: 'views/k02/k0201/SelectProject',

        // 开票账号选择画面
        SelectInvoiceAccount: 'views/k02/k0205/SelectInvoiceAccount',

        // 日程管理--指定公开组别
        SelectUserGroupModal: 'views/k06/k0607/modules/SelectUserGroupModal',

        // 商机
        BusinessOpportunitySelectModal: 'views/k03/k0304/BusinessOpportunitySelectModal',

        // 销售单
        SalesOrderSelectModal: 'views/k03/k0304/SalesOrderSelectModal',

        // 销售人员
        UserSaleSelectModal: 'views/k03/k0303/UserSaleSelectModal',

        // 招标信息
        BidInvitationSelectModal: 'views/k03/k0305/BidInvitationSelectModal',

        // 开票选择
        SelectInvoiceDetail: 'views/k02/k0205/SelectInvoiceDetail',

        // 部门年度预算选择
        SelectDepartBudget: 'views/k05/k0501/SelectDepartBudget',

        // 收款账户选择
        SelectRecipientAccount: 'views/k05/k0506/SelectRecipientAccount',

        // 收款账户选择
        SelectSupplier: 'views/k04/k0401/SelectSupplier',

        // 地域住宿补贴规则
        SelectRegionSubsidyRule: 'views/k04/k0407/SelectRegionSubsidyRule',

        // 出差申请
        SelectBusinessTripRecord: 'views/k04/k0408/SelectBusinessTripRecord',

        // 采购合同
        SelectProcurementContract: 'views/k04/k0401/SelectProcurementContract',

        // 知识库标签
        RepositoryTag: 'views/k06/k0601/RepositoryTag',

        // 租赁选择画面
        SelectRentment: 'views/k06/k0608/SelectRentment',

        // 固定资产选择画面
        SelectFixedAssets: 'views/k04/k0402/SelectFixedAssets',

        // 采购需求选择画面
        SelectDemand: 'views/k04/k0401/SelectDemand',

        // 开销户申请选择画面
        SelectBankAccount: 'views/k05/k0504/SelectBankAccount',
      },
    }
  },
  mounted() {},
  computed: {
    text: {
      get: function () {
        if (
          this.$attrs['data-__field'] &&
          this.$attrs['data-__field'].value &&
          this.$attrs['data-__field'].value.length > 0
        ) {
          this.returnData = this.$attrs['data-__field'].value
          return this.returnData
            .map((item) => {
              return item.text
            })
            .join('、')
        }
        if (this.$attrs.value && this.$attrs.value.length > 0) {
          this.returnData = this.$attrs.value
          if (this.returnData.map) {
            return this.returnData
              .map((item) => {
                return item.text
              })
              .join('、')
          } else {
            return this.returnData
          }
        }
      },
      set: function (val) {},
    },
    extraTexts: {
      get: function () {
        if (
          this.$attrs['data-__field'] &&
          this.$attrs['data-__field'].value &&
          this.$attrs['data-__field'].value.length > 0
        ) {
          this.returnData = this.$attrs['data-__field'].value
          return XEUtils.filter(this.returnData, (r) => !!r.extraTexts).map((item) => {
            return item.extraTexts
          })
        }
        if (this.$attrs.value && this.$attrs.value.length > 0) {
          this.returnData = this.$attrs.value
          return XEUtils.filter(this.returnData, (r) => !!r.extraTexts).map((item) => {
            return item.extraTexts
          })
        }
      },
      set: function (val) {},
    },
    linkText: {
      get: function () {
        if (
          this.$attrs['data-__field'] &&
          this.$attrs['data-__field'].value &&
          this.$attrs['data-__field'].value.length > 0
        ) {
          this.returnData = this.$attrs['data-__field'].value
          return this.$attrs['data-__field'].value
            .map((item) => {
              return item.linkText
            })
            .join('、')
        }
        if (this.$attrs.value && this.$attrs.value.length > 0) {
          this.returnData = this.$attrs.value
          return this.$attrs.value
            .map((item) => {
              return item.linkText
            })
            .join('、')
        }
      },
    },
    iCloseCircleShow: function () {
      if (
        (this.$attrs['data-__field'] &&
          this.$attrs['data-__field'].value &&
          this.$attrs['data-__field'].value.length > 0 &&
          this.$attrs['data-__field'].value[0].text &&
          this.$attrs['data-__field'].value[0].text.length > 0) ||
        (this.$attrs.value &&
          this.$attrs.value.length > 0 &&
          this.$attrs.value[0].text &&
          this.$attrs.value[0].text.length > 0)
      ) {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    text: function (newVal) {
      // クリアの場合、returnDataもクリアする
      if (!newVal) {
        this.returnData = []
      }
    },
  },
  methods: {
    // getText(list) {
    //   let _text = ''
    //   list.forEach((item, index) => {
    //     if (index < list.length - 1) {
    //       _text += item.text + ';'
    //     } else {
    //       _text += item.text
    //     }
    //   })
    //   return _text
    // },
    handleOpen(e) {
      if (!this.disabled) {
        if (e == 'link') {
          this.src = require('@/' + this.components[this.componentLink]).default
        } else {
          this.src = require('@/' + this.components[this.component]).default
        }

        // 選択済みvalueを取得する
        if (this.returnData && this.returnData.length > 0) {
          this.params.selectedValue = this.returnData.map((item) => {
            return item.value
          })
        } else {
          this.params.selectedValue = []
        }

        var that = this
        var interval = setInterval(() => {
          if (that.$refs.ModalForm && that.$refs.ModalForm.visible != undefined) {
            console.info('open modal ⇒ ' + that.src.name)
            that.$refs.ModalForm.visible = true
            window.clearInterval(interval)

            // destroyOnCloseはいつも効かないため、手動でモーダルをdestroyする
            that.$watch(
              () => {
                return that.$refs.ModalForm.visible
              },
              (val) => {
                // visibleがfalse、即ちモーダルが閉じられた場合
                if (!val) {
                  // v-ifでdestroyする
                  that.src = ''
                }
              }
            )
          }
        }, 100)
      }
    },
    doCloseCircle() {
      this.returnData = []

      if (this.beforeValSet) {
        this.beforeValSet().then((res) => {
          if (!res) {
            return
          } else {
            this.$emit('input', [])
            this.$emit('change', [])
          }
        })
      } else {
        this.$emit('input', [])
        this.$emit('change', [])
      }
    },
    getList(list) {
      if (list && !Array.isArray(list)) {
        this.returnData = []
        this.returnData.push(list)
      } else {
        this.returnData = list
      }

      if (this.beforeValSet) {
        this.beforeValSet().then((res) => {
          if (!res) {
            return
          } else {
            if (this.returnData && this.returnData.length) {
              this.$emit('input', this.returnData)
              this.$emit('change', this.returnData)
            } else {
              this.$emit('input', [])
              this.$emit('change', [])
            }
          }
        })
      } else {
        if (this.returnData && this.returnData.length) {
          this.$emit('input', this.returnData)
          this.$emit('change', this.returnData)
        } else {
          this.$emit('input', [])
          this.$emit('change', [])
        }
      }
    },
    handleChange(remains) {
      var temp = []
      remains.forEach((remain) => {
        temp.push(XEUtils.filter(this.returnData, (item) => item.value == remain.value)[0])
      })

      this.getList(temp)
    },
    inputChange(e) {
      if (this.beforeValSet) {
        this.beforeValSet().then((res) => {
          if (!res) {
            return
          } else {
            let list = [{ value: e.target.value, text: e.target.value }]
            this.$emit('input', list)
            this.$emit('change', list)
          }
        })
      } else {
        let list = [{ value: e.target.value, text: e.target.value }]
        this.$emit('input', list)
        this.$emit('change', list)
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .anticon-search {
  transition: all 0.3s;
}

.j-input-popup {
  position: relative;
}

.j-input-popup-input {
  .cursor-pointer {
    cursor: text !important;
  }
}
/** default start ***********************/
.j-input-popup-default {
  .cursor-pointer {
    cursor: pointer !important;
    //width: 100%;
  }
}

.cursor-pointer.ant-input {
  padding-right: 30px;
  color: rgba(0, 0, 0, 0.25);
  text-overflow: ellipsis;
}

.cursor-pointer.ant-input {
  background: transparent;
  color: transparent;
}

.input-readonly {
  width: 100%;
  position: relative;

  .i-icon {
    z-index: 1;
    position: absolute;
    // bottom: 0px;
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
  }

  .i-close-circle {
    opacity: 0;
    transition: all 0.3s;
    right: 10px;
    color: rgba(0, 0, 0, 0.25);
    font-size: 12px;

    ///deep/ svg {
    //  width: 12px;
    //  height: 12px;
    //}
  }

  .i-search {
    transition: all 0.3s;
    color: rgba(0, 0, 0, 0.25);
    right: 8px;
    pointer-events: none;
  }
}
/** default end **********************  */

/** link start *******************************/
.link {
  padding-right: 24px;

  .i-search {
    transition: all 0.3s;
    left: 8px;
  }

  .i-search.link-text-show {
    right: 8px;
    left: unset;
  }

  .i-search:hover {
    color: rgba(0, 0, 0, 0.85);
  }

  .cursor-pointer {
    // text-decoration: underline;
    min-height: 1em;
    display: inline-block;
    text-indent: 5px;
  }
}
/** link end *******************************/

.j-input /deep/ [role='combobox'] {
  cursor: pointer;
  background: #fff;
  padding-right: 30px;
}

.j-input.default /deep/ li.ant-select-selection__choice {
  color: var(--color-font);
  background-color: #fafafa;
  border: 1px solid var(--color-tb-border);
}

.j-input-popup /deep/ .ant-select-dropdown {
  display: none !important;
}

.j-input-popup-wrapper.disabled {
  .cursor-pointer,
  .i-icon,
  .j-input /deep/ [role='combobox'] {
    cursor: not-allowed !important;
  }
}

.j-input-popup-wrapper:hover {
  .i-close-circle {
    opacity: 1;
  }
}

.j-input-display {
  position: absolute;
  width: 100%;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 25px;
  background: white;
  padding-left: 8px;
  line-height: 32px;
}

.j-input-popup-wrapper.disabled .j-input-display {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
}
</style>
